import { Routes } from '@angular/router';
import { authGuard, guestGuard, rootRedirectGuard } from '@core/guards';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    canActivate: [rootRedirectGuard],
    children: [], // Empty children since we're redirecting
  },
  {
    path: 'login',
    loadComponent: () => import('./routes/login/login.component').then((m) => m.LoginComponent),
    canActivate: [guestGuard], // Prevent authenticated users from accessing login
  },
  {
    path: 'dashboard',
    loadChildren: () => import('./routes/dashboard/dashboard.routes').then((m) => m.routes),
    canActivate: [authGuard],
  },
  {
    path: 'approvechange',
    loadComponent: () =>
      import('./routes/approvechange/approve-change.component').then(
        (m) => m.ApproveChangeComponent
      ),
    // No auth guard - accessible without login
  },
  {
    // Catch-all route - redirect to login for unauthenticated users
    path: '**',
    redirectTo: 'login',
  },
];
